// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__GzcNy","inner":"Footer_inner__2YbF1"};